<template>
    <div>
        <h1>测试页面</h1>
    </div>
</template>

<script>
export default {
    name: 'exit',
    data () {
        return {
            data:""
        }
    }
}
</script>

<style scoped>

</style>
      


// WEBPACK FOOTER //
// src/components/car.vue